module.exports = __webpack_public_path__ + "app/images/webex_cc_logo.d7dd84f7.png";